(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-product-switcher-ninja"] && !Shopify.designMode) return;
  try {
    
  class NcProductSwitcher extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse(this.querySelector('[data-nc-data]').textContent); }
      catch (e) { console.error('nc-switcher data parse', e); return; }
      this.benefits = (this.getAttribute('data-benefits') || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
      this.state = { type: this.getAttribute('data-default-type') || 'drink', flavor: null, size: null, plan: (this.getAttribute('data-default-plan') === 'subscribe' ? 'subscribe' : 'onetime'), planId: null };
      if (!this.data[this.state.type] && this.state.type === 'powder') this.state.type = 'drink';
      this.cache();
      this.setTypeIcons();
      this.bind();
      this.render();
      var self = this;
      if ('requestIdleCallback' in window) requestIdleCallback(function () { self.preload(); });
      else setTimeout(function () { self.preload(); }, 1200);
    }

    cache() {
      this.elTypeBtns = [].slice.call(this.querySelectorAll('[data-nc-type]'));
      this.elFlavorWrap = this.querySelector('[data-nc-flavor]');
      this.elFlavorGroup = this.querySelector('[data-nc-flavor-group]');
      this.elSizeWrap = this.querySelector('[data-nc-size]');
      this.elSizeGroup = this.querySelector('[data-nc-size-group]');
      this.elPlanWrap = this.querySelector('[data-nc-plan]');
      this.elPlanGroup = this.querySelector('[data-nc-plan-group]');
      this.elSubExtra = this.querySelector('[data-nc-sub-extra]');
      this.elMain = this.querySelector('[data-nc-media-main]');
      this.elThumbs = this.querySelector('[data-nc-thumbs]');
      this.elTitle = this.querySelector('[data-nc-title]');
      this.elVariantId = this.querySelector('[data-nc-variant-id]');
      this.elSellingPlan = this.querySelector('[data-nc-selling-plan]');
      this.elAtc = this.querySelector('[data-add-to-cart]');
      this.elAtcText = this.querySelector('[data-nc-atc-text]');
      this.elPrice = this.querySelector('[data-nc-price]');
      this.atcLabel = this.elAtcText ? this.elAtcText.textContent.trim() : 'Add to cart';
      this.accs = [].slice.call(this.querySelectorAll('[data-nc-acc]'));
      this.accs.forEach(function (d) { d._fb = d.querySelector('.nc-acc__content').innerHTML; });
    }

    img(p) { var f = p && p.featured_image; if (!f) return (p && p.images && p.images[0]) || ''; return typeof f === 'string' ? f : (f.src || ''); }

    setTypeIcons() {
      var drink = this.data.drink && (this.data.drink.chocolate || this.data.drink.strawberry || this.data.drink.vanilla || this.data.drink.bundle);
      var di = this.querySelector('[data-nc-type-icon="drink"]'); if (di && drink) di.src = this.img(drink.product);
      var pw = this.data.powder; var pi = this.querySelector('[data-nc-type-icon="powder"]'); if (pi && pw) pi.src = this.img(pw.product);
    }

    bind() {
      var self = this;
      this.elTypeBtns.forEach(function (b) { b.addEventListener('click', function () { self.state.type = b.getAttribute('data-nc-type'); self.state.flavor = null; self.state.size = null; self.render(); }); });
    }

    money(c) { return '$' + (c / 100).toFixed(2); }
    label(k) { return ({ chocolate: 'Chocolate', strawberry: 'Strawberry', vanilla: 'Vanilla', bundle: 'Bundle' })[k] || k; }
    entry() { return this.state.type === 'powder' ? this.data.powder : (this.data.drink ? this.data.drink[this.state.flavor] : null); }

    optIndex(p, name) { var o = p.options || []; for (var i = 0; i < o.length; i++) { var n = (o[i] && o[i].name) ? o[i].name : o[i]; if (n === name) return i; } return -1; }
    optValues(p, name) { var idx = this.optIndex(p, name), out = []; if (idx < 0) return out; (p.variants || []).forEach(function (v) { var val = v.options[idx]; if (val && out.indexOf(val) < 0) out.push(val); }); return out; }

    flavors() {
      if (this.state.type === 'powder') { var p = this.data.powder && this.data.powder.product; if (!p) return []; return this.optValues(p, 'Flavor').map(function (v) { return { key: v.toLowerCase(), label: v }; }); }
      var d = this.data.drink || {}, self = this;
      return ['chocolate', 'strawberry', 'vanilla', 'bundle'].filter(function (k) { return d[k]; }).map(function (k) { return { key: k, label: self.label(k) }; });
    }

    resolveVariant(entry) {
      var p = entry.product, vs = p.variants || [];
      if (this.state.type === 'powder') {
        var fi = this.optIndex(p, 'Flavor'), si = this.optIndex(p, 'Size'), self = this;
        return vs.find(function (v) { return (fi < 0 || (v.options[fi] || '').toLowerCase() === self.state.flavor) && (si < 0 || v.options[si] === self.state.size); }) || vs[0];
      }
      var sidx = this.optIndex(p, 'Size'), st = this;
      if (sidx >= 0 && this.state.size) return vs.find(function (v) { return v.options[sidx] === st.state.size; }) || vs[0];
      return vs[0];
    }

    render() {
      var self = this;
      this.elTypeBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-nc-type') === self.state.type); });
      this.querySelector('[data-nc-type-group]').hidden = !this.data.powder;

      var flavors = this.flavors();
      if (!flavors.length) return;
      if (!this.state.flavor || !flavors.find(function (f) { return f.key === self.state.flavor; })) this.state.flavor = flavors[0].key;
      var entry = this.entry(); if (!entry) { this.state.flavor = flavors[0].key; entry = this.entry(); }
      if (!entry) return;

      var sizes = this.optValues(entry.product, 'Size');
      if (sizes.length) { if (!this.state.size || sizes.indexOf(this.state.size) < 0) this.state.size = sizes[0]; } else { this.state.size = null; }

      var variant = this.resolveVariant(entry);
      var plans = entry.sellingPlans || [];
      if (this.state.plan === 'subscribe' && !plans.length) this.state.plan = 'onetime';
      if (plans.length && (!this.state.planId || !plans.find(function (p) { return p.id === self.state.planId; }))) this.state.planId = plans[0].id;

      this.renderFlavors(flavors);
      this.renderSizes(entry, sizes);
      this.renderPlans(entry, variant, plans);
      this.renderMedia(entry, variant);
      this.renderTitleAndAtc(entry, variant);
      this.renderAccordions(entry);
    }

    renderFlavors(flavors) {
      var self = this; this.elFlavorGroup.hidden = flavors.length < 2; this.elFlavorWrap.innerHTML = '';
      var sw = { chocolate: 'var(--sw-choc)', strawberry: 'var(--sw-straw)', vanilla: 'var(--sw-van)', bundle: 'var(--sw-bundle)' };
      flavors.forEach(function (f) {
        var btn = document.createElement('button'); btn.type = 'button';
        btn.className = 'nc-flavor' + (f.key === self.state.flavor ? ' is-active' : '');
        btn.innerHTML = '<span class="nc-flavor__dot" style="background:' + (sw[f.key] || '#888') + '"></span>' + f.label;
        btn.addEventListener('click', function () { self.state.flavor = f.key; self.state.size = null; self.render(); });
        self.elFlavorWrap.appendChild(btn);
      });
    }

    renderSizes(entry, sizes) {
      var self = this; this.elSizeGroup.hidden = sizes.length < 1; this.elSizeWrap.innerHTML = '';
      var sd = entry.sizeData || {};
      sizes.forEach(function (sz) {
        var btn = document.createElement('button'); btn.type = 'button';
        btn.className = 'nc-size' + (sz === self.state.size ? ' is-active' : '');
        var meta = sd[sz] || {};
        var html = '<span class="nc-size__name">' + sz + '</span>';
        if (meta.sub) html += '<span class="nc-size__sub">' + meta.sub + '</span>';
        if (meta.tab) html += '<span class="nc-size__tab">' + meta.tab + '</span>';
        btn.innerHTML = html;
        btn.addEventListener('click', function () { self.state.size = sz; self.render(); });
        self.elSizeWrap.appendChild(btn);
      });
    }

    subInfo(entry, variant, planId) {
      var a = entry.alloc && entry.alloc[variant.id]; if (!a) return null;
      var pid = planId && a[planId] ? planId : Object.keys(a)[0];
      return a[pid] ? { price: a[pid].price, planId: pid } : null;
    }

    renderPlans(entry, variant, plans) {
      var self = this;
      if (!plans.length) { this.elPlanGroup.hidden = true; this.elPlanWrap.innerHTML = ''; this.elSubExtra.hidden = true; this.elSubExtra.innerHTML = ''; return; }
      this.elPlanGroup.hidden = false;
      var sub = this.subInfo(entry, variant, this.state.planId);
      var pct = sub ? Math.round((1 - sub.price / variant.price) * 100) : 0;
      this.elPlanWrap.innerHTML = '';

      var one = document.createElement('button'); one.type = 'button';
      one.className = 'nc-plan' + (this.state.plan === 'onetime' ? ' is-active' : '');
      one.innerHTML = '<span class="nc-plan__label"><span class="nc-plan__radio"></span>Buy one time</span><span class="nc-plan__price">' + this.money(variant.price) + '</span>';
      one.addEventListener('click', function () { self.state.plan = 'onetime'; self.render(); });
      this.elPlanWrap.appendChild(one);

      if (sub) {
        var s = document.createElement('button'); s.type = 'button';
        s.className = 'nc-plan' + (this.state.plan === 'subscribe' ? ' is-active' : '');
        s.innerHTML = '<span class="nc-plan__label"><span class="nc-plan__radio"></span>Subscribe &amp; Save' + (pct > 0 ? ' <span class="nc-plan__save">' + pct + '%</span>' : '') + '</span>' +
          '<span class="nc-plan__price"><s>' + this.money(variant.price) + '</s>' + this.money(sub.price) + '</span>';
        s.addEventListener('click', function () { self.state.plan = 'subscribe'; self.render(); });
        this.elPlanWrap.appendChild(s);
      }

      // expanded subscribe extras
      if (this.state.plan === 'subscribe' && sub) {
        var html = '';
        if (this.benefits.length) { html += '<ul class="nc-bullets">'; this.benefits.forEach(function (b) { html += '<li>' + b + '</li>'; }); html += '</ul>'; }
        if (plans.length) {
          html += '<div class="nc-cadence"><select data-nc-cadence aria-label="Delivery frequency">';
          plans.forEach(function (p) { html += '<option value="' + p.id + '"' + (p.id === self.state.planId ? ' selected' : '') + '>' + p.name + '</option>'; });
          html += '</select></div>';
        }
        this.elSubExtra.innerHTML = html; this.elSubExtra.hidden = false;
        var sel = this.elSubExtra.querySelector('[data-nc-cadence]');
        if (sel) sel.addEventListener('change', function () { self.state.planId = parseInt(sel.value, 10); self.render(); });
      } else { this.elSubExtra.hidden = true; this.elSubExtra.innerHTML = ''; }
    }

    renderMedia(entry, variant) {
      var p = entry.product;
      var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [(typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src)] : []);
      var main = (variant && variant.featured_image) ? (typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src) : (imgs[0] || '');
      if (this.elMain) { this.elMain.src = main; this.elMain.alt = p.title || ''; }
      if (this.elThumbs) {
        var self = this; this.elThumbs.innerHTML = '';
        imgs.slice(0, 4).forEach(function (src) {
          var b = document.createElement('button'); b.type = 'button';
          b.className = (src === main ? 'is-active' : '');
          b.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
          b.addEventListener('click', function () { self.elMain.src = src; [].slice.call(self.elThumbs.children).forEach(function (c) { c.classList.remove('is-active'); }); b.classList.add('is-active'); });
          self.elThumbs.appendChild(b);
        });
      }
    }

    renderTitleAndAtc(entry, variant) {
      if (this.elTitle) this.elTitle.textContent = entry.product.title || '';
      var available = variant && variant.available;
      var priceCents = variant ? variant.price : 0, compare = null;
      if (this.state.plan === 'subscribe') { var sub = this.subInfo(entry, variant, this.state.planId); if (sub) { compare = priceCents; priceCents = sub.price; } }
      else if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) { compare = variant.compare_at_price; }
      if (this.elVariantId) this.elVariantId.value = variant ? variant.id : '';
      if (this.elSellingPlan) { if (this.state.plan === 'subscribe' && this.state.planId) { this.elSellingPlan.value = this.state.planId; this.elSellingPlan.disabled = false; } else { this.elSellingPlan.value = ''; this.elSellingPlan.disabled = true; } }
      if (this.elPrice) this.elPrice.innerHTML = available ? (' - ' + this.money(priceCents) + (compare ? ' <s>' + this.money(compare) + '</s>' : '')) : '';
      if (this.elAtcText) this.elAtcText.textContent = available ? this.atcLabel : 'Sold out';
      if (this.elAtc) this.elAtc.disabled = !available;
    }

    renderAccordions(entry) {
      if (!this.accs || !this.accs.length) return;
      var p = entry.product || {};
      var map = { description: p.description, ingredients: entry.ingredients, nutrition: entry.nutrition };
      this.accs.forEach(function (det) {
        var key = det.getAttribute('data-nc-acc');
        var el = det.querySelector('.nc-acc__content');
        var val = map[key];
        var html;
        if (val && ('' + val).trim()) { html = (key === 'description') ? val : ('' + val).replace(/\n/g, '<br>'); }
        else { html = det._fb || ''; }
        el.innerHTML = html;
        det.hidden = el.innerHTML.trim().length === 0;
      });
    }

    preload() {
      var urls = [], self = this;
      var collect = function (e) { if (!e || !e.product) return; (e.product.images || []).slice(0, 2).forEach(function (u) { urls.push(u); }); urls.push(self.img(e.product)); };
      if (this.data.drink) for (var k in this.data.drink) collect(this.data.drink[k]);
      collect(this.data.powder);
      urls.filter(Boolean).forEach(function (u) { var i = new Image(); i.src = u; });
    }
  }
  if (!customElements.get('nc-product-switcher')) customElements.define('nc-product-switcher', NcProductSwitcher);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-product-switcher"] && !Shopify.designMode) return;
  try {
    
  class NcProductSwitcher extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse(this.querySelector('[data-nc-data]').textContent); }
      catch (e) { console.error('nc-switcher data parse', e); return; }
      this.benefits = (this.getAttribute('data-benefits') || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
      this.state = { type: this.getAttribute('data-default-type') || 'drink', flavor: null, size: null, plan: (this.getAttribute('data-default-plan') === 'subscribe' ? 'subscribe' : 'onetime'), planId: null };
      if (!this.data[this.state.type] && this.state.type === 'powder') this.state.type = 'drink';
      this.cache();
      this.setTypeIcons();
      this.bind();
      this.render();
      var self = this;
      if ('requestIdleCallback' in window) requestIdleCallback(function () { self.preload(); });
      else setTimeout(function () { self.preload(); }, 1200);
    }

    cache() {
      this.elTypeBtns = [].slice.call(this.querySelectorAll('[data-nc-type]'));
      this.elFlavorWrap = this.querySelector('[data-nc-flavor]');
      this.elFlavorGroup = this.querySelector('[data-nc-flavor-group]');
      this.elSizeWrap = this.querySelector('[data-nc-size]');
      this.elSizeGroup = this.querySelector('[data-nc-size-group]');
      this.elPlanWrap = this.querySelector('[data-nc-plan]');
      this.elPlanGroup = this.querySelector('[data-nc-plan-group]');
      this.elSubExtra = this.querySelector('[data-nc-sub-extra]');
      this.elMain = this.querySelector('[data-nc-media-main]');
      this.elThumbs = this.querySelector('[data-nc-thumbs]');
      this.elTitle = this.querySelector('[data-nc-title]');
      this.elVariantId = this.querySelector('[data-nc-variant-id]');
      this.elSellingPlan = this.querySelector('[data-nc-selling-plan]');
      this.elAtc = this.querySelector('[data-add-to-cart]');
      this.elAtcText = this.querySelector('[data-nc-atc-text]');
      this.elPrice = this.querySelector('[data-nc-price]');
      this.atcLabel = this.elAtcText ? this.elAtcText.textContent.trim() : 'Add to cart';
      this.accs = [].slice.call(this.querySelectorAll('[data-nc-acc]'));
      this.accs.forEach(function (d) { d._fb = d.querySelector('.nc-acc__content').innerHTML; });
    }

    img(p) { var f = p && p.featured_image; if (!f) return (p && p.images && p.images[0]) || ''; return typeof f === 'string' ? f : (f.src || ''); }

    setTypeIcons() {
      var drink = this.data.drink && (this.data.drink.chocolate || this.data.drink.strawberry || this.data.drink.vanilla || this.data.drink.bundle);
      var di = this.querySelector('[data-nc-type-icon="drink"]'); if (di && drink) di.src = this.img(drink.product);
      var pw = this.data.powder; var pi = this.querySelector('[data-nc-type-icon="powder"]'); if (pi && pw) pi.src = this.img(pw.product);
    }

    bind() {
      var self = this;
      this.elTypeBtns.forEach(function (b) { b.addEventListener('click', function () { self.state.type = b.getAttribute('data-nc-type'); self.state.flavor = null; self.state.size = null; self.render(); }); });
    }

    money(c) { return '$' + (c / 100).toFixed(2); }
    label(k) { return ({ chocolate: 'Chocolate', strawberry: 'Strawberry', vanilla: 'Vanilla', bundle: 'Bundle' })[k] || k; }
    entry() { return this.state.type === 'powder' ? this.data.powder : (this.data.drink ? this.data.drink[this.state.flavor] : null); }

    optIndex(p, name) { var o = p.options || []; for (var i = 0; i < o.length; i++) { var n = (o[i] && o[i].name) ? o[i].name : o[i]; if (n === name) return i; } return -1; }
    optValues(p, name) { var idx = this.optIndex(p, name), out = []; if (idx < 0) return out; (p.variants || []).forEach(function (v) { var val = v.options[idx]; if (val && out.indexOf(val) < 0) out.push(val); }); return out; }

    flavors() {
      if (this.state.type === 'powder') { var p = this.data.powder && this.data.powder.product; if (!p) return []; return this.optValues(p, 'Flavor').map(function (v) { return { key: v.toLowerCase(), label: v }; }); }
      var d = this.data.drink || {}, self = this;
      return ['chocolate', 'strawberry', 'vanilla', 'bundle'].filter(function (k) { return d[k]; }).map(function (k) { return { key: k, label: self.label(k) }; });
    }

    resolveVariant(entry) {
      var p = entry.product, vs = p.variants || [];
      if (this.state.type === 'powder') {
        var fi = this.optIndex(p, 'Flavor'), si = this.optIndex(p, 'Size'), self = this;
        return vs.find(function (v) { return (fi < 0 || (v.options[fi] || '').toLowerCase() === self.state.flavor) && (si < 0 || v.options[si] === self.state.size); }) || vs[0];
      }
      var sidx = this.optIndex(p, 'Size'), st = this;
      if (sidx >= 0 && this.state.size) return vs.find(function (v) { return v.options[sidx] === st.state.size; }) || vs[0];
      return vs[0];
    }

    render() {
      var self = this;
      this.elTypeBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-nc-type') === self.state.type); });
      this.querySelector('[data-nc-type-group]').hidden = !this.data.powder;

      var flavors = this.flavors();
      if (!flavors.length) return;
      if (!this.state.flavor || !flavors.find(function (f) { return f.key === self.state.flavor; })) this.state.flavor = flavors[0].key;
      var entry = this.entry(); if (!entry) { this.state.flavor = flavors[0].key; entry = this.entry(); }
      if (!entry) return;

      var sizes = this.optValues(entry.product, 'Size');
      if (sizes.length) { if (!this.state.size || sizes.indexOf(this.state.size) < 0) this.state.size = sizes[0]; } else { this.state.size = null; }

      var variant = this.resolveVariant(entry);
      var plans = entry.sellingPlans || [];
      if (this.state.plan === 'subscribe' && !plans.length) this.state.plan = 'onetime';
      if (plans.length && (!this.state.planId || !plans.find(function (p) { return p.id === self.state.planId; }))) this.state.planId = plans[0].id;

      this.renderFlavors(flavors);
      this.renderSizes(entry, sizes);
      this.renderPlans(entry, variant, plans);
      this.renderMedia(entry, variant);
      this.renderTitleAndAtc(entry, variant);
      this.renderAccordions(entry);
    }

    renderFlavors(flavors) {
      var self = this; this.elFlavorGroup.hidden = flavors.length < 2; this.elFlavorWrap.innerHTML = '';
      var sw = { chocolate: 'var(--sw-choc)', strawberry: 'var(--sw-straw)', vanilla: 'var(--sw-van)', bundle: 'var(--sw-bundle)' };
      flavors.forEach(function (f) {
        var btn = document.createElement('button'); btn.type = 'button';
        btn.className = 'nc-flavor' + (f.key === self.state.flavor ? ' is-active' : '');
        btn.innerHTML = '<span class="nc-flavor__dot" style="background:' + (sw[f.key] || '#888') + '"></span>' + f.label;
        btn.addEventListener('click', function () { self.state.flavor = f.key; self.state.size = null; self.render(); });
        self.elFlavorWrap.appendChild(btn);
      });
    }

    renderSizes(entry, sizes) {
      var self = this; this.elSizeGroup.hidden = sizes.length < 1; this.elSizeWrap.innerHTML = '';
      var sd = entry.sizeData || {};
      sizes.forEach(function (sz) {
        var btn = document.createElement('button'); btn.type = 'button';
        btn.className = 'nc-size' + (sz === self.state.size ? ' is-active' : '');
        var meta = sd[sz] || {};
        var html = '<span class="nc-size__name">' + sz + '</span>';
        if (meta.sub) html += '<span class="nc-size__sub">' + meta.sub + '</span>';
        if (meta.tab) html += '<span class="nc-size__tab">' + meta.tab + '</span>';
        btn.innerHTML = html;
        btn.addEventListener('click', function () { self.state.size = sz; self.render(); });
        self.elSizeWrap.appendChild(btn);
      });
    }

    subInfo(entry, variant, planId) {
      var a = entry.alloc && entry.alloc[variant.id]; if (!a) return null;
      var pid = planId && a[planId] ? planId : Object.keys(a)[0];
      return a[pid] ? { price: a[pid].price, planId: pid } : null;
    }

    renderPlans(entry, variant, plans) {
      var self = this;
      if (!plans.length) { this.elPlanGroup.hidden = true; this.elPlanWrap.innerHTML = ''; this.elSubExtra.hidden = true; this.elSubExtra.innerHTML = ''; return; }
      this.elPlanGroup.hidden = false;
      var sub = this.subInfo(entry, variant, this.state.planId);
      var pct = sub ? Math.round((1 - sub.price / variant.price) * 100) : 0;
      this.elPlanWrap.innerHTML = '';

      var one = document.createElement('button'); one.type = 'button';
      one.className = 'nc-plan' + (this.state.plan === 'onetime' ? ' is-active' : '');
      one.innerHTML = '<span class="nc-plan__label"><span class="nc-plan__radio"></span>Buy one time</span><span class="nc-plan__price">' + this.money(variant.price) + '</span>';
      one.addEventListener('click', function () { self.state.plan = 'onetime'; self.render(); });
      this.elPlanWrap.appendChild(one);

      if (sub) {
        var s = document.createElement('button'); s.type = 'button';
        s.className = 'nc-plan' + (this.state.plan === 'subscribe' ? ' is-active' : '');
        s.innerHTML = '<span class="nc-plan__label"><span class="nc-plan__radio"></span>Subscribe &amp; Save' + (pct > 0 ? ' <span class="nc-plan__save">' + pct + '%</span>' : '') + '</span>' +
          '<span class="nc-plan__price"><s>' + this.money(variant.price) + '</s>' + this.money(sub.price) + '</span>';
        s.addEventListener('click', function () { self.state.plan = 'subscribe'; self.render(); });
        this.elPlanWrap.appendChild(s);
      }

      // expanded subscribe extras
      if (this.state.plan === 'subscribe' && sub) {
        var html = '';
        if (this.benefits.length) { html += '<ul class="nc-bullets">'; this.benefits.forEach(function (b) { html += '<li>' + b + '</li>'; }); html += '</ul>'; }
        if (plans.length) {
          html += '<div class="nc-cadence"><select data-nc-cadence aria-label="Delivery frequency">';
          plans.forEach(function (p) { html += '<option value="' + p.id + '"' + (p.id === self.state.planId ? ' selected' : '') + '>' + p.name + '</option>'; });
          html += '</select></div>';
        }
        this.elSubExtra.innerHTML = html; this.elSubExtra.hidden = false;
        var sel = this.elSubExtra.querySelector('[data-nc-cadence]');
        if (sel) sel.addEventListener('change', function () { self.state.planId = parseInt(sel.value, 10); self.render(); });
      } else { this.elSubExtra.hidden = true; this.elSubExtra.innerHTML = ''; }
    }

    renderMedia(entry, variant) {
      var p = entry.product;
      var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [(typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src)] : []);
      var main = (variant && variant.featured_image) ? (typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src) : (imgs[0] || '');
      if (this.elMain) { this.elMain.src = main; this.elMain.alt = p.title || ''; }
      if (this.elThumbs) {
        var self = this; this.elThumbs.innerHTML = '';
        imgs.slice(0, 4).forEach(function (src) {
          var b = document.createElement('button'); b.type = 'button';
          b.className = (src === main ? 'is-active' : '');
          b.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
          b.addEventListener('click', function () { self.elMain.src = src; [].slice.call(self.elThumbs.children).forEach(function (c) { c.classList.remove('is-active'); }); b.classList.add('is-active'); });
          self.elThumbs.appendChild(b);
        });
      }
    }

    renderTitleAndAtc(entry, variant) {
      if (this.elTitle) this.elTitle.textContent = entry.product.title || '';
      var available = variant && variant.available;
      var priceCents = variant ? variant.price : 0, compare = null;
      if (this.state.plan === 'subscribe') { var sub = this.subInfo(entry, variant, this.state.planId); if (sub) { compare = priceCents; priceCents = sub.price; } }
      else if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) { compare = variant.compare_at_price; }
      if (this.elVariantId) this.elVariantId.value = variant ? variant.id : '';
      if (this.elSellingPlan) { if (this.state.plan === 'subscribe' && this.state.planId) { this.elSellingPlan.value = this.state.planId; this.elSellingPlan.disabled = false; } else { this.elSellingPlan.value = ''; this.elSellingPlan.disabled = true; } }
      if (this.elPrice) this.elPrice.innerHTML = available ? (' - ' + this.money(priceCents) + (compare ? ' <s>' + this.money(compare) + '</s>' : '')) : '';
      if (this.elAtcText) this.elAtcText.textContent = available ? this.atcLabel : 'Sold out';
      if (this.elAtc) this.elAtc.disabled = !available;
    }

    renderAccordions(entry) {
      if (!this.accs || !this.accs.length) return;
      var p = entry.product || {};
      var map = { description: p.description, ingredients: entry.ingredients, nutrition: entry.nutrition };
      this.accs.forEach(function (det) {
        var key = det.getAttribute('data-nc-acc');
        var el = det.querySelector('.nc-acc__content');
        var val = map[key];
        var html;
        if (val && ('' + val).trim()) { html = (key === 'description') ? val : ('' + val).replace(/\n/g, '<br>'); }
        else { html = det._fb || ''; }
        el.innerHTML = html;
        det.hidden = el.innerHTML.trim().length === 0;
      });
    }

    preload() {
      var urls = [], self = this;
      var collect = function (e) { if (!e || !e.product) return; (e.product.images || []).slice(0, 2).forEach(function (u) { urls.push(u); }); urls.push(self.img(e.product)); };
      if (this.data.drink) for (var k in this.data.drink) collect(this.data.drink[k]);
      collect(this.data.powder);
      urls.filter(Boolean).forEach(function (u) { var i = new Image(); i.src = u; });
    }
  }
  if (!customElements.get('nc-product-switcher')) customElements.define('nc-product-switcher', NcProductSwitcher);

  } catch(e) { console.error(e); }
})();
})();
